export default "__VITE_ASSET__b7355d3f__"